import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMentionModule } from 'ng-zorro-antd/mention';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { MomentModule } from 'ngx-moment';
import { AddParcelItemTypeComponent } from './account-settings-drawer';
import { ChangeCompanyNameModalComponent } from './account-settings-drawer/change-company-name-modal/change-company-name-modal.component';
import { CompanySettingsComponent } from './account-settings-drawer/company-settings/company-settings.component';
import { DiscountRatesComponent } from './account-settings-drawer/discount-rates/discount-rates.component';
import { EditDiscountRateComponent } from './account-settings-drawer/edit-discount-rate/edit-discount-rate.component';
import { SmsTemplatesComponent } from './account-settings-drawer/sms-templates/sms-templates.component';

@NgModule({
  declarations: [],
  imports: [
    ChangeCompanyNameModalComponent,
    CompanySettingsComponent,
    CommonModule,
    NzGridModule,
    NzDrawerModule,
    ReactiveFormsModule,
    NzDividerModule,
    NzButtonModule,
    NzUploadModule,
    NzIconModule,
    NzModalModule,
    NzPageHeaderModule,
    NzTableModule,
    // S3UploaderModule.forRoot({
    //   region: environment.s3.region,
    //   bucket: environment.s3.buspro_company_logos_bucket,
    //   credentials: { accessKeyId: environment.s3.accessKeyId, secretAccessKey: environment.s3.secretAccessKey }
    // }),
    NzSpinModule,
    NzFormModule,
    NzInputModule,
    MomentModule,
    NzTabsModule,
    NzMentionModule,
    FormsModule,
    DigitOnlyModule,
    SmsTemplatesComponent,
    EditDiscountRateComponent,
    AddParcelItemTypeComponent,
    DiscountRatesComponent,
  ],
  providers: [NzMessageService],
})
export class SettingsModule {}
